import { Constants } from "../../controller/net/constant/Constants";
/**
 * Balance.ts
 */
export class Balance {
    constructor(amount, currency, type, cash, bonus) {
        this.serverAmount = amount;
        this.amount = amount;
        this.currency = currency;
        this.type = type;
        this.cash = cash;
        this.bonus = bonus;
    }
    static create(data) {
        let currency = data.getString(Constants.PROPERTY_CURRENCY_CODE);
        if (typeof currency !== "string") {
            currency = data.getString(Constants.PROPERTY_CURRENCY_CODE_SHORT);
        }
        let type = data.getString(Constants.PROPERTY_TYPE);
        if (typeof type !== "string") {
            type = data.getString(Constants.PROPERTY_TYPE_SHORT);
        }
        let amount = data.getNumber(Constants.PROPERTY_AMOUNT);
        if (typeof amount !== "number") {
            amount = data.getNumber(Constants.PROPERTY_AMOUNT_SHORT);
        }
        return new Balance(amount, currency, type);
    }
    reset() {
        this.amount = this.serverAmount;
    }
    getAmount() {
        return this.amount;
    }
    getCurrency() {
        return this.currency;
    }
    getType() {
        return this.type;
    }
    getKey() {
        return this.currency + ":" + this.type;
    }
    getServerAmount() {
        return this.serverAmount;
    }
    add(value) {
        this.amount += value;
        this.validate();
    }
    subtract(value) {
        this.amount -= value;
        this.validate();
    }
    validate() {
        if (this.amount <= 0) {
            this.amount = 0;
        }
    }
    getCash() {
        return this.cash;
    }
    getBonus() {
        return this.bonus;
    }
}
//# sourceMappingURL=Balance.js.map